<template>
  <ContentPage>
    <template #header>
    <Progress :step="4" :steps="5">
      <h2 class="py-1" style="line-height: 28px;">
        What services do you offer?
      </h2>
      <div class="my-2 mx-6" style="font-size: 14px">
        Check all that apply. (Selected items should be green.)  You can update these at any time on your "You" page. 
      </div>
    </Progress>
    </template>

    <v-container class="mt-0 rounded-lg white">
      <v-row class="mt-n1 pb-2">
        <v-col cols="12">
          <ServicesInput v-model="service_ids" />
        </v-col>
      </v-row>
    </v-container>

    <template #footer>
      <div class="d-flex justify-center py-2 rounded-lg white">
        <v-btn @click="backClick">Back</v-btn>
        <v-btn color="primary" class="ml-4" @click="nextClick">Next</v-btn>
      </div>
    </template>
  </ContentPage>
</template>

<script>
import { ContentPage } from '@/components/pages'
import Progress from './progress'
import { ServicesInput } from '@/components/inputs'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'WizardStepE',

  components: { ContentPage, Progress, ServicesInput },

  data: () => ({
    service_ids: [],
  }),

  computed: {
    ...mapGetters('wizard', ['progress']),
  },

  watch: {
    offered(newVal) {
      this.service_ids = newVal.map(s => s.service_id)
    }
  },

  methods: {
    ...mapActions('wizard', ['updateProgress']),

    backClick() {
      this.$router.replace( { name: 'wizardD' } )
    },

    async nextClick() {
      await this.updateProgress({ pro: { service_ids: this.service_ids } })      
      this.$router.replace( { name: 'wizardF' } )
    },
  },

  created() {
    this.service_ids = this.progress.pro.service_ids || []
  },
}
</script>
